import type { ReactElement, ReactNode } from 'react';

import styles from './StatusBadge.module.css';

export interface StatusBadgeProps {
    tone: 'success' | 'danger' | 'info' | 'neutral';
    children: ReactNode;
}

export function StatusBadge({ tone, children }: StatusBadgeProps): ReactElement {
    return <span className={[styles.badge, styles[tone]].join(' ')}>{children}</span>;
}
